// Display helpers for sales promo codes. A code gives `percent_off`% off the
// subscription package for `duration_cycles` billing cycles of the vendor's own
// period; the signup payment is cycle 1.

export const PERIOD_LABELS = { MONTHLY: "Monthly", ANNUALLY: "Yearly" };

export function describeDuration(promo) {
  const cycles = Number(promo.duration_cycles);
  const periods = promo.billing_periods || [];
  const only = periods.length === 1 ? periods[0] : null;
  if (cycles === 1) return only === "ANNUALLY" ? "the first year" : "the first payment";
  if (only === "MONTHLY") return `the first ${cycles} monthly payments`;
  if (only === "ANNUALLY") return `the first ${cycles} years`;
  return `the first ${cycles} payments (monthly or yearly)`;
}

export function describeDiscount(promo) {
  return `${Number(promo.percent_off)}% off the package for ${describeDuration(promo)}`;
}

/** What a sales person needs to know: can this code be used right now? */
export function promoState(promo, now = new Date()) {
  if (!promo.active) return "paused";
  if (promo.valid_from && new Date(promo.valid_from) > now) return "scheduled";
  if (promo.expires_at && new Date(promo.expires_at) <= now) return "expired";
  if (promo.max_redemptions != null && promo.redemption_count >= promo.max_redemptions) return "used_up";
  return "active";
}

export const PROMO_STATE_TAGS = {
  active: { color: "green", label: "Active" },
  paused: { color: "default", label: "Paused" },
  scheduled: { color: "blue", label: "Scheduled" },
  expired: { color: "orange", label: "Expired" },
  used_up: { color: "red", label: "Used up" },
};

export function usageLabel(promo) {
  return promo.max_redemptions == null
    ? `${promo.redemption_count} used`
    : `${promo.redemption_count} / ${promo.max_redemptions} used`;
}

/** Next charge while a promo still has discounted payments left (recurring amount is VAT-inclusive). */
export function discountedAmount(amount, percentOff) {
  return Math.round((Number(amount) * (100 - Number(percentOff)) / 100 + Number.EPSILON) * 100) / 100;
}

/** One line for ops about a promo running on a subscription (`subscription.discount`). */
export function describeRunningDiscount(discount) {
  if (!discount) return null;
  const used = `${discount.cycles_applied} of ${discount.duration_cycles} discounted payments used`;
  const state = discount.status === "COMPLETED" ? "finished" : `${discount.remaining_cycles} left`;
  return `${discount.code} · ${Number(discount.percent_off)}% off · ${used} (${state})`;
}
